import React from "react";
import { TermClause, TermsResponse } from "../../../../../types/terms";
import {
  defaultCommunicationConsentSection,
  defaultTermsSection,
} from "./terms-list.consts";

interface TermsJSX {
  termsSection: JSX.Element;
  communicationConsentSection: JSX.Element;
}

export const addTermHtml = (term: TermClause) => {
  if (
    term.summary.includes(
      "[Electronic Communication Consent Details](#details)"
    )
  ) {
    return term.summary.replace(
      "[Electronic Communication Consent Details](#details)",
      `<a id="communicationConsentLink">Electronic Communication Consent Details</a>`
    );
  }

  const linkTextList = term.summary.match(/\[[^\]]*\]/g);
  const foundLinks =
    linkTextList?.map((linkText) => {
      return term.links.find((link) => {
        if (link.name === linkText.slice(1, -1)) {
          return link;
        }
      });
    }) ?? [];

  const filteredLinks = foundLinks.flatMap((link) => (link ? [link] : []));

  let termText = term.summary;
  filteredLinks.forEach((link) => {
    termText = termText.replace(
      `[${link.name}](#link)`,
      `<a href="${link.href}" target="_blank" rel="noopener noreferrer">${link.name}</a>`
    );
  });

  if (termText.includes("\n1.  ")) {
    const lines = termText.split("\n");
    const additionalText = lines.slice(0, 1).join("\n");
    const items = lines.slice(1).filter((item) => item.trim().startsWith("1."));

    return `${additionalText.split("\n").join("</p>\n<p>")}\n<ul>\n${items
      .map((item) => `<li>${item.trim().substring(3)}</li>`)
      .join("\n")}\n</ul>`;
  }

  return termText;
};

export const convertTermsToJSX = (
  terms: TermsResponse | null | undefined
): TermsJSX => {
  if (!terms) {
    return {
      termsSection: defaultTermsSection,
      communicationConsentSection: defaultCommunicationConsentSection,
    };
  }

  const termsConsent = terms.sections.find(
    (section) => section.name === "Terms"
  );

  const termList = termsConsent?.clauses.map((clause) => {
    return addTermHtml(clause);
  });

  const listItems = termList?.map((termHtmlString, index) => (
    <li dangerouslySetInnerHTML={{ __html: termHtmlString }} key={index}></li>
  ));

  const communicationConsentString =
    termsConsent?.clauses.find((clause) => {
      if (clause.refId === "electronic-communication-consent") {
        return clause;
      }
    })?.details ?? "";

  const lines = communicationConsentString.replace(/\n\n/g, "\n").split("\n");
  const additionalText = lines.slice(0, 2).join("\n");
  const items = lines.slice(2).filter((item) => item.trim().startsWith("1."));

  const htmlList = `<p>${additionalText
    .split("\n")
    .join("</p>\n<p>")}</p>\n<ol>\n${items
    .map((item) => `<li>${item.trim().substring(3)}</li>`)
    .join("\n")}\n</ol>`;

  return {
    termsSection: (
      <>
        <p className="bold">Please read the below carefully.</p>
        <p className="bold">By submitting an application:</p>
        <ul>{listItems}</ul>
      </>
    ),
    communicationConsentSection: (
      <div
        className="communication-consent"
        dangerouslySetInnerHTML={{ __html: htmlList }}
      ></div>
    ),
  };
};
